import { useSelector } from "react-redux";
import {
  qrFramesInitialState,
  qrOptionsInitialState,
  qrSettingsInitialState,
  qrTextInitialState,
} from "../constants/common";
import { deepEqual } from "./helpersThirdStep";

function useQrConfigs() {
  const qrSettings = useSelector((state) => state.qrSettings);
  const qrFrames = useSelector((state) => state.qrFrames);
  const qrOptions = useSelector((state) => state.qrOptions);
  const qrText = useSelector((state) => state.qrText);
  const generatorEditConfigs = useSelector(
    (state) => state.saveValue.generatorEditConfigs
  );

  const currentConfigs = {
    ...qrSettings,
    ...qrFrames,
    ...qrOptions,
    ...qrText,
  };
  const initialConfigs = {
    ...qrSettingsInitialState,
    ...qrFramesInitialState,
    ...qrOptionsInitialState,
    ...qrTextInitialState,
  };

  const isGeneratorConfigsChanged = () =>
    !deepEqual(currentConfigs, generatorEditConfigs);

  return {
    qrSettingsInitialState,
    qrTextInitialState,
    qrFramesInitialState,
    qrOptionsInitialState,
    initialConfigs,
    currentConfigs,
    isGeneratorConfigsChanged,
  };
}

export default useQrConfigs;
